import { SagaIterator } from 'redux-saga';
import { call, cancel, put, take, takeEvery } from 'redux-saga/effects';
import {
  AngebotsId,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  NavigationRoute,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutActions } from '../checkout.actions';

export function* watchLocationChanged(): SagaIterator {
  yield takeEvery(GlobalActions.LOCATION_CHANGED, safeSaga(addOrderIndexSaga, App.SHOP_CHECKOUT));
}

export function* addOrderIndexSaga(action: GlobalAction<NavigationRoute>): SagaIterator {
  const globalPut = GlobalPut.getInstance();

  if (action.payload.appId !== App.SHOP_CHECKOUT) {
    return yield cancel();
  }

  yield call(globalPut.put, new GlobalActions().requestAngeboteInWarenkorb());
  const angeboteInWarenkorbAction: GlobalAction<Array<AngebotsId>> = yield take(
    GlobalActions.ANGEBOTE_IN_WARENKORB_PROVIDED,
  );
  const angeboteInWarenkorb = angeboteInWarenkorbAction.payload;
  yield put(new CheckoutActions().sortProdukte(angeboteInWarenkorb));
}
